<pux-translate :text="'_TXT_PUX_REQUIRED_'"></pux-translate>